"use client";

import { UnsavedChangesAlert } from "@/components/shared/unsaved-changes-alert";

interface UnsavedChangesBannerProps {
  hasUnsavedChanges: boolean;
  onUndo: () => void;
  onSave: () => void;
  isSaving?: boolean;
  title?: string;
  description?: string;
  undoLabel?: string;
  saveLabel?: string;
  className?: string;
}

export function UnsavedChangesBanner({
  hasUnsavedChanges,
  onUndo,
  onSave,
  isSaving = false,
  className = "",
}: UnsavedChangesBannerProps) {
  return (
    <UnsavedChangesAlert
      hasUnsavedChanges={hasUnsavedChanges}
      onUndo={onUndo}
      onSave={onSave}
      isSaving={isSaving}
      className={className}
    />
  );
}
